import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

/**
 * Tracks in-flight resumable / chunked downloads so idle logout can pause
 * the same way it does for active uploads.
 */
@Injectable({
  providedIn: 'root',
})
export class DownloadActivityService {
  private readonly activeCount$ = new BehaviorSubject<number>(0);

  readonly inProgress$: Observable<boolean> = this.activeCount$.pipe(
    map((count) => count > 0),
    distinctUntilChanged()
  );

  hasInProgressDownloads(): boolean {
    return this.activeCount$.value > 0;
  }

  begin(): void {
    this.activeCount$.next(this.activeCount$.value + 1);
  }

  end(): void {
    this.activeCount$.next(Math.max(0, this.activeCount$.value - 1));
  }
}
